import React, { useEffect } from 'react';
import { AppState } from '@Redux/store';
import { Dispatch } from '@Redux/type';
import { connect } from 'react-redux';
import NewArmyListForm from './NewArmyListForm';
import { ArmyListNewPresenter } from '@Selectors/builder/myBuilder/builder/new/ArmyListNewPresenter';
import { container } from '@Container';
import { TYPES } from '@Types';
import { ArmiesAction, ArmyListAction, FoldersAction, VersionsAction } from '@Redux/actions';
import Scroll from 'react-scroll';
import myBuilderSlice from '@Redux/reducers/builder/myBuilder.slice';
import { ArmyListCreateParams } from '@Builder/myBuilder/builder/new/army_list/validate';
import { MyBuilderActionState } from '@Stores/builder/MyBuilderState';

const ArmyListNew: React.FC<ArmyListNewProps> = (
  {
    loadVersions,
    loadArmies,
    loadFolders,
    cancel,
    importList,
    datas,
    handleSubmit
  }
) => {
  useEffect(() => {
    loadVersions();
    loadArmies();
    loadFolders();

    Scroll.scroller.scrollTo('NewArmyListElement', {
      duration: 1000,
      delay: 100,
      smooth: true,
      offset: -50 // Scrolls to element + 50 pixels down the page
    });
  }, []);
  const Element = Scroll.Element;

  return (
    <div className="mt-2">
      <Element name="NewArmyListElement" />
      {datas.isLoading && <div className="loader" />}
      {!datas.isLoading &&
        <NewArmyListForm versions={datas.versions} armies={datas.armies} folders={datas.folders} cancel={cancel}
                         importList={importList} onSubmit={handleSubmit} canSubmit={datas.canSubmit} />}
    </div>
  );
};


const mapStateToProps = (state: AppState) => ({
  datas: ArmyListNewPresenter(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  const armiesAction = container.get<ArmiesAction>(TYPES.Actions.ArmiesAction);
  const versionsAction = container.get<VersionsAction>(TYPES.Actions.VersionsAction);
  const foldersAction = container.get<FoldersAction>(TYPES.Actions.FoldersAction);
  const armyListAction = container.get<ArmyListAction>(TYPES.Actions.ArmyListAction);
  return {
    importList: () => dispatch(myBuilderSlice.actions.setRequest(MyBuilderActionState.ArmyListFormat)),
    cancel: () => dispatch(myBuilderSlice.actions.cancel()),
    handleSubmit: (values: ArmyListCreateParams) => dispatch(armyListAction.create(values)),
    loadVersions: () => dispatch(versionsAction.fetchData()),
    loadArmies: () => dispatch(armiesAction.fetchData()),
    loadFolders: () => dispatch(foldersAction.fetchData())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ArmyListNew);

type ArmyListNewProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>;
